export const TERMS_REQUIRED_MESSAGE =
  "Please agree to the Terms of Use, Subscriber Agreement and Merge Gateway Terms, and read the Privacy Policy.";
